import AzureAdSettingsTab from './azure-ad-settings';

export default AzureAdSettingsTab;
